import { ApiService } from './api';

// API service instance
const apiService = ApiService.getInstance();

export interface Year {
    ano_fiscal_id: number;
    ano: number;
    descricao: string;
    dtInicio: string;
    dtFim: string;
    status: string;
}
interface YearResponse {
    ano_fiscal_id: number;
    ano: number;
    descricao: string;
    dtInicio: string;
    dtFim: string;
    status: string;
}

export const yearService = {
    // Get available years for the current entity and area
    async getAvailableYears(entityId: string, areaId: string): Promise<Year[]> {
        try {
            // Fetch data from the backend API with entity and area parameters
            const response: YearResponse[] = await apiService.get(`/anofiscal/${entityId}/${areaId}/usuario`);
            // Transform backend response to Year format
            const years: Year[] = response.map((item) => ({
                ano_fiscal_id: item.ano_fiscal_id,
                ano: item.ano,
                status: item.status,
                descricao: item.descricao,
                dtInicio: item.dtInicio,
                dtFim: item.dtFim
            }));

            // Sort years in descending order (most recent first)
            years.sort((a, b) => b.ano - a.ano);

            return years;
        } catch (error) {
            console.error('Error fetching years from API:', error);
            throw error;
        }
    },

    // Get all years for admin purposes
    async getAllYears(): Promise<Year[]> {
        try {
            // Fetch all years from the admin endpoint
            const response: YearResponse[] = await apiService.get('/anofiscal');
            // Transform backend response to Year format
            const years: Year[] = response.map((item) => ({
                ano_fiscal_id: item.ano_fiscal_id,
                ano: item.ano,
                status: item.status,
                descricao: item.descricao,
                dtInicio: item.dtInicio,
                dtFim: item.dtFim
            }));

            // Sort years in descending order (most recent first)
            years.sort((a, b) => b.ano - a.ano);

            return years;
        } catch (error) {
            console.error('Error fetching all years from API:', error);
            throw error;
        }
    },

    // Set the current year for the user
    async setCurrentYear(yearId: number): Promise<void> {
        // Store the current year ID in localStorage
        localStorage.setItem('currentYearId', yearId.toString());
    },

    // Get the current year for the user
    getCurrentYear(): number | null {
        const yearId = localStorage.getItem('currentYearId');
        return yearId ? parseInt(yearId) : null;
    }
}; 